import { useEffect, useState } from 'react';
import { adminApi, type WorkersResponse } from './api/adminClient';
import StatusBadge from './components/StatusBadge';

function relTime(iso: string | null): string {
  if (!iso) return 'nunca';
  const ms = Date.now() - new Date(iso).getTime();
  if (ms < 60_000) return 'ahora';
  if (ms < 3_600_000) return `hace ${Math.floor(ms / 60_000)} min`;
  if (ms < 86_400_000) return `hace ${Math.floor(ms / 3_600_000)} h`;
  return `hace ${Math.floor(ms / 86_400_000)} d`;
}

const labels: Record<string, string> = {
  send: 'Envío de aplicaciones',
  dolSync: 'Sync de ofertas DOL',
  bounceScanner: 'Detector de bounces',
  replyScanner: 'Detector de respuestas',
};

export default function AdminWorkersPage() {
  const [data, setData] = useState<WorkersResponse | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    const fetchOnce = () => adminApi.workers().then((d) => { if (!cancelled) setData(d); }).catch((e: Error) => { if (!cancelled) setErr(e.message); });
    fetchOnce();
    const t = setInterval(fetchOnce, 30_000);
    return () => { cancelled = true; clearInterval(t); };
  }, []);

  if (err) return <div className="alert alert-error">{err}</div>;
  if (!data) return <div className="p-8 text-center opacity-60">Cargando…</div>;

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">Workers</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {data.workers.map((w) => (
          <div key={w.name} className="card bg-base-100 shadow">
            <div className="card-body">
              <div className="flex items-center justify-between">
                <h2 className="card-title">{labels[w.name] ?? w.name}</h2>
                <StatusBadge value={w.health} />
              </div>
              <div className="text-sm space-y-1 mt-2">
                <div>
                  <span className="opacity-60">Última ejecución:</span> {relTime(w.last_run_at)}
                  {w.last_run_at && <span className="opacity-60 text-xs ml-1">({new Date(w.last_run_at).toLocaleString()})</span>}
                </div>
                <div><span className="opacity-60">Duración:</span> {w.duration_ms} ms</div>
                <div>
                  <span className="opacity-60">Procesados:</span> {w.items_processed}
                  {' · '}
                  <span className="opacity-60">Fallidos:</span> {w.items_failed}
                </div>
                <div className="text-xs opacity-60">
                  Umbral stale: {Math.floor(w.stale_threshold_ms / 60_000)} min
                </div>
              </div>
              {w.last_error && (
                <details className="mt-2">
                  <summary className="text-error text-sm cursor-pointer">Último error</summary>
                  <pre className="text-xs bg-base-200 p-2 rounded mt-1 overflow-x-auto whitespace-pre-wrap">{w.last_error}</pre>
                </details>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
